import { keyframes } from '@emotion/react';
import styled from '@emotion/styled';
import { useEffect, useState } from 'react';

const Backdrop = styled.div<{ visible: boolean }>`
    position: fixed;
    z-index: 1;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    background-color: ${({ visible }) => (visible ? 'rgba(0, 0, 0, 0.5)' : 'transparent')};
    transition: background-color 0.5s;
`;

const CountdownContainer = styled.div<{ visible: boolean }>`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    gap: 24px;
    padding: 24px 32px;
    background-color: ${({ theme }) => theme.colors.secondary[900]};
    border-radius: 16px;

    position: absolute;
    top: 80px;
    z-index: 3;

    color: ${({ theme }) => theme.colors.black[50]};
    font-size: 28px;
    font-weight: 700;
    letter-spacing: -0.56px;

    transition: opacity 0.5s;
    opacity: ${({ visible }) => (visible ? 1 : 0)};
`;

const fade = keyframes`
  0%, 100% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
`;

const Number = styled.div`
    font-size: 56px;
    line-height: 150%;
    letter-spacing: -1.76px;
    animation: ${fade} 1s infinite;
`;

interface Props {
    countdownTime: number;
    onCountdownEnd: () => void;
}

export const Countdown = ({ countdownTime, onCountdownEnd }: Props) => {
    const [count, setCount] = useState<number>(countdownTime);
    const [isVisible, setIsVisible] = useState<boolean>(true);

    useEffect(() => {
        if (count > 0) {
            const timer = setTimeout(() => setCount(count - 1), 1000);
            return () => clearTimeout(timer);
        }
        if (count <= 0) {
            setTimeout(() => setIsVisible(false), 500);
            onCountdownEnd();
        }
    }, [count]);

    if (!isVisible) return null;

    return (
        <>
            <Backdrop visible={count !== 0} />
            <CountdownContainer visible={count !== 0}>
                Recording starts in
                <Number>{count}</Number>
            </CountdownContainer>
        </>
    );
};
